import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { getOptionalEndpointTimeoutOptions } from '~/scopes/product-core/composables/useFetch/utils/getOptionalEndpointTimeoutOptions'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchReviewsSummary() {
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    `pp-review-summary-${productId}`,
    () =>
      $httpFetch('/reviews/products/:uuid/reviews-summary', {
        pathParams: { uuid: productId },
      }),
    {
      ...getOptionalEndpointTimeoutOptions(),
      dedupe: 'defer',
    },
  )
}
